// Product page interactions: gallery, zoom, options, message preview, bundle, sticky buy
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;
  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };

  /* gallery */
  var stage = root.querySelector('[data-stage]');
  var slides = stage ? Array.prototype.slice.call(stage.querySelectorAll('[data-slide]')) : [];
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
  var counter = root.querySelector('[data-count]');
  var idx = 0;
  function show(i) {
    idx = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.hidden = n !== idx; });
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
    if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
  }
  thumbs.forEach(function (t, n) {
    t.addEventListener('click', function () { show(n); });
    t.addEventListener('mouseenter', function () { show(n); });
  });
  if (slides.length) show(0);
  document.addEventListener('keydown', function (e) {
    if (!slides.length) return;
    if (e.key === 'ArrowRight') show(idx + 1);
    if (e.key === 'ArrowLeft') show(idx - 1);
  });
  if (stage) {
    stage.addEventListener('click', function () { stage.classList.toggle('is-zoom'); });
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
      var y = ((e.clientY - r.top) / r.height * 100).toFixed(1);
      slides.forEach(function (s) {
        var m = s.firstElementChild || s;
        m.style.transformOrigin = x + '% ' + y + '%';
      });
    });
    stage.addEventListener('mouseleave', function () { stage.classList.remove('is-zoom'); });
  }

  /* variant chips */
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var unitEl = root.querySelector('[data-unit]');
  var idInput = root.querySelector('[data-variant-id]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var variantChips = Array.prototype.slice.call(root.querySelectorAll('[data-variant]'));
  function pickVariant(chip) {
    variantChips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
    var cents = parseInt(chip.dataset.price, 10);
    var count = parseInt(chip.dataset.count || '1', 10);
    if (priceEl) priceEl.textContent = money(cents);
    if (stickyPrice) stickyPrice.textContent = money(cents);
    if (compareEl) {
      var cmp = parseInt(chip.dataset.compare || '0', 10);
      compareEl.textContent = cmp > cents ? money(cmp) : '';
      compareEl.hidden = !(cmp > cents);
    }
    if (unitEl) unitEl.textContent = count > 1 ? money(Math.round(cents / count)) + ' per card' : 'single card';
    if (idInput && chip.dataset.id) idInput.value = chip.dataset.id;
  }
  variantChips.forEach(function (c) { c.addEventListener('click', function () { pickVariant(c); }); });
  var initial = root.querySelector('[data-variant][aria-pressed="true"]') || variantChips[0];
  if (initial) pickVariant(initial);

  /* quantity */
  root.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, v + (b.dataset.step === 'up' ? 1 : -1));
      });
    });
  });

  /* message preview */
  var ta = root.querySelector('[data-note-input]');
  var out = root.querySelector('[data-note-out]');
  var counterN = root.querySelector('[data-note-count]');
  var placeholder = out ? out.textContent : '';
  function paint() {
    if (!out) return;
    var v = ta.value.trim();
    out.textContent = v || placeholder;
    out.classList.toggle('is-empty', !v);
    if (counterN) counterN.textContent = ta.value.length + ' / 240';
  }
  if (ta && out) { out.classList.add('is-empty'); ta.addEventListener('input', paint); }
  root.querySelectorAll('[data-prompt]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-prompt]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      if (ta) { ta.value = b.dataset.prompt; paint(); ta.focus(); }
    });
  });

  /* bundle builder */
  var bundle = root.querySelector('[data-bundle]');
  if (bundle) {
    var boxes = Array.prototype.slice.call(bundle.querySelectorAll('input[type=checkbox]'));
    var totalEl = bundle.querySelector('[data-bundle-total]');
    var saveEl = bundle.querySelector('[data-bundle-save]');
    var btn = bundle.querySelector('[data-bundle-btn]');
    function tally() {
      var sum = 0, n = 0;
      boxes.forEach(function (b) { if (b.checked) { sum += parseInt(b.dataset.price, 10); n++; } });
      var disc = n >= 3 ? Math.round(sum * 0.1) : 0;
      if (totalEl) totalEl.textContent = money(sum - disc);
      if (saveEl) saveEl.textContent = n === 0 ? 'Pick two or more' : (disc ? 'Saving ' + money(disc) + ' — bundle of ' + n : (3 - n) + ' more for 10% off');
      if (btn) { btn.disabled = n === 0; btn.textContent = n ? 'Add ' + n + ' to bag' : 'Add to bag'; }
    }
    boxes.forEach(function (b) { b.addEventListener('change', tally); });
    tally();
  }

  /* sticky buy bar */
  var buyrow = root.querySelector('[data-buyrow]');
  var bar = document.querySelector('[data-sticky]');
  if (buyrow && bar) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
    }, { threshold: 0 }).observe(buyrow);
  }

  /* horizontal rails */
  document.querySelectorAll('[data-rail]').forEach(function (wrap) {
    var rail = wrap.querySelector('.hrail');
    wrap.querySelectorAll('[data-rail-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        rail.scrollBy({ left: (b.dataset.railDir === 'next' ? 1 : -1) * 286 * 2, behavior: 'smooth' });
      });
    });
  });

  /* review filter chips (visual) */
  root.querySelectorAll('[data-revfilter]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-revfilter]').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
    });
  });
})();
